import { AfterViewInit, Component, OnDestroy, ViewChild } from '@angular/core';
import { Message } from 'primeng/api';
import { Toast } from 'primeng/toast';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-alert-message',
  templateUrl: './alert-message.component.html',
  styleUrls: ['./alert-message.component.scss']
})
export class AlertMessageComponent implements OnDestroy, AfterViewInit {

  private subscription: Subscription = new Subscription();

  @ViewChild('toast') toast: Toast | null = null;

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngAfterViewInit(): void {
    this.subscription.add(
      this.toast?.messageService.messageObserver.subscribe((m) => {
        const message: Message = m as Message;
        //
        // Deixa a mensagem como sticky se for de erro e não tiver sido definido esse valor manualmente

        if (message && message.sticky === undefined) {

          switch (message.severity) {
            case 'error':
              message.sticky = true;
              break;
            default:
              message.sticky = false;
          }
        }

        if (message && message.life === undefined) {
          message.life = 3000;
        }

      })
    );
  }

}
